import {transform as ol_proj_transform, fromLonLat} from 'ol/proj.js';
import ol_control_SearchJSON from "ol-ext/control/SearchJSON.js";
import allProjs from "./../proj/proj4Defs.js";
import proj4 from "proj4";
import {register} from "ol/proj/proj4.js";
import ol_ext_element from 'ol-ext/util/element.js'

export default class SearchAzure extends ol_control_SearchJSON {
    constructor(options) {
        options = options || {};
        options.className = options.className || 'nominatim';
        options.typing = options.typing || 500;
        options.copy = `© ${new Date().getFullYear()} TomTom, Microsoft`;
        options.url = options.url
            ? options.url
            : 'https://atlas.microsoft.com/search/address/json';
        options.historyText = options.historyText
            ? options.historyText
            : 'History';
        super(options);

        var datas_ = {
            type: options.type,
            historyText: options.historyText,
            searchResultText: options.searchResultText,
            noItemsText: options.noItemsText
        };
        this.set('polygon', options.polygon);
        this.set('viewbox', options.viewbox);
        this.set('bounded', options.bounded);
        this.set('key', options.key);
        this.set('language', options.language);
        this.set('type', options.type);
        this.set('search_country', options.searchCountry);
        this.set('_LocFunction', options._LocFunction);
        this.set('datas_', datas_);

        if (options.searchByPostal == 'True' || options.searchByPostal == true) {
            this.set('search_postal', options.searchPostal);
            // this.set('search_city', options.searchCity);
        } else {
            this.set('search_city', options.searchCity);
        }

        if (options.preventUseFilter == 'True' || options.preventUseFilter == true) {
            this.set('_useFilter', false);
        }else{
            this.set('_useFilter', true);
        }

        // Header
        var h6 = this._h6 = document.createElement('h6');
        h6.setAttribute(
            'style',
            'margin: .5rem 0 0 .2rem;display: inline-block;width: calc(100% - 2rem)'
        );
        h6.innerHTML = 'History:';

        this
            .element
            .querySelectorAll('ul.history')[0]
            .before(h6);
        // Remove History
        if (options.removeHistory) {
            var remove = this._remove = ol_ext_element.create('BUTTON', {
                class: 'ol-remove-history',
                html: '<i class="far fa-trash-alt"></i>',
                click: function () {
                    this._input.value = '';
                    this.clearHistory();
                }.bind(this)
            });
            this
                .element
                .querySelectorAll('ul.history')[0]
                .before(remove);
        }
        // Hr
        var hr = document.createElement('hr');
        hr.setAttribute('style', 'margin:.5rem 0;')
        this
            .element
            .querySelectorAll('ul.history')[0]
            .before(hr);

    }
    /** Returns the text to be displayed in the menu
   *	@param {ol.Feature} f the feature
  *	@return {string} the text to be displayed in the index
  *	@api
  */
    getTitle(f) {
        var info = [];
        if (f.class) 
            info.push(f.class);
        if (f.type) 
            info.push(f.type);
        var title = f.display_name + (
            info.length
                ? "<i>" + info.join(' - ') + "</i>"
                : ''
        );
        if (f.icon) 
            title = "<img src='" + f.icon + "' />" + title;
        return (title);
    }
    /**
   * @param {string} s the search string
   * @return {Object} request data (as key:value)
   * @api
   */
    requestData(s) {
        var isLocation = false;

        if (s.includes(',')) {

            function isNumeric(str) {
                if (typeof str != "string") 
                    return false // we only process strings!
                return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
                !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
            }

            var first = s.split(',')[0];
            var last = s.split(',')[1];
            if (isNumeric(first) && isNumeric(last)) {
                isLocation = true;
            }
        }

        if (isLocation == true) {

            var first = parseFloat(s.split(',')[0]);
            var last = parseFloat(s.split(',')[1]);

            return {query: `${first},${last}`, isLocation: isLocation, first: first, last: last, 'subscription-key': this.get('key')};

        } else {

            var data = {
                query: s,
                'subscription-key': this.get('key')
            }

            if (this.get('search_postal') && this.get('search_postal') != null) {
                // data['postalCode'] = this.get('search_postal');
                data.query += ` ${this.get('search_postal')}`;
            }

            if (this.get('search_country') && this.get('search_country') != null) {
                data['country'] = this.get('search_country');
            }

            if (this.get('search_city') && this.get('search_city') != null) {
                // data['city'] = this.get('search_city');
                data.query += ` ${this.get('search_city')}`;
            }

            // let bbox = null; if (this.get('search_postal')) {     bbox = await
            // this.getBoundingBox(this.get('search_postal')); } else if
            // (this.get('search_city')) {     bbox = await
            // this.getBoundingBox(this.get('search_city')); } if (bbox) data['boundingBox']
            // = bbox; if (this.get('viewbox'))     data.viewbox = this.get('viewbox');
            return data;

        }
    }

    // Get bounding box from city or postal code using Nominatim
    async getBoundingBox(barrier) {
        // Return from cache if available
        if (this.cache[barrier]) 
            return this.cache[barrier];
        
        const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
            barrier
        )}`;
        const res = await fetch(url, {
            headers: {
                "User-Agent": "MyMapLibrary/1.0"
            } // required by Nominatim
        });
        const data = await res.json();

        if (!data || data.length === 0) 
            throw new Error(`Barrier not found: ${barrier}`);
        
        // Take first result's bounding box: [south, north, west, east]
        const bbox = data[0]
            .boundingbox
            .map(Number);

        // Reorder to SWlat, SWlon, NElat, NElon
        const reordered = [
            bbox[0], bbox[2], bbox[1], bbox[3]
        ];
        this.cache[barrier] = reordered;

        return reordered;
    }

    /** A ligne has been clicked in the menu > dispatch event
   *	@param {any} f the feature, as passed in the autocomplete
  *	@api
  */
    select(f) {
        var c = [
            Number(f['position'].lon),
            Number(f['position'].lat)
        ];
        // Add coordinate to the event
        try {
            proj4.defs(this.getMap().getView().getProjection().getCode(), allProjs[
                this
                    .getMap()
                    .getView()
                    .getProjection()
                    .getCode()
            ]);
            register(proj4);
            // c = fromLonLat(c, this.getMap().getView().getProjection());
            c = ol_proj_transform(c, 'EPSG:4326', this.getMap().getView().getProjection());
        } catch (e) {
            console.error(e);
        }
        this.dispatchEvent({type: "select", search: f, coordinate: c});
    }

    /** Reverse geocode
   * @param {ol.coordinate} coord
   * @api
   */
    reverseGeocode(coord, cback) {
        var lonlat = ol_proj_transform(
            coord,
            this.getMap().getView().getProjection(),
            'EPSG:4326'
        );
        this.ajax(this.get('url').replace('search', 'reverse'), {
            lon: lonlat[0],
            lat: lonlat[1],
            format: 'json'
        }, function (resp) {
            if (cback) {
                cback.call(this, [resp]);
            } else {
                if (resp && !resp.error) {
                    this._handleSelect(resp, true);
                }
                //this.setInput('', true);
            }
        }.bind(this));
    }

    /**
   * Handle server response to pass the features array to the display list
   * @param {any} response server response
   * @return {Array<any>} an array of feature
   * @api
   */
    handleResponse(response) {
        return response.results || response;
    }
    /**/

    /** Draw the list
  * @param {Array} auto an array of search result
  * @private
  */
    drawList_(auto, fromHistory) {
        var this_datas = this.get('datas_');
        var self = this;
        var ul = this
            .element
            .querySelector("ul.autocomplete");
        ul.innerHTML = '';
        this._list = [];

        var isSearch = true;

        if (!auto) {
            var input = this
                .element
                .querySelector("input.search");
            var value = input.value;
            if (!value || fromHistory == true) {
                auto = this.get('history');
            } else {
                return;
            }
            var historyText = this_datas
                ? this_datas['historyText']
                    ? this_datas['historyText']
                    : 'History'
                : 'History';
            ul.setAttribute('class', 'autocomplete history');
            if (this._h6) {
                this._h6.innerHTML = historyText + ':';
            }
            if (this._remove) {
                this._remove.style.display = 'inline-block';
            }
            isSearch = false;
        } else {
            ul.setAttribute('class', 'autocomplete');
            var searchResultText = this_datas
                ? this_datas['searchResultText']
                    ? this_datas['searchResultText']
                    : 'Search result'
                : 'Search result';
            if (this._h6) {
                this._h6.innerHTML = searchResultText + ':';
            }
            if (this._remove) {
                this._remove.style.display = 'none';
            }
        }

        var noItemsText = this_datas
            ? this_datas['noItemsText']
                ? this_datas['noItemsText']
                : 'No items'
            : 'No items';

        if (auto['addresses'] && auto['addresses'].length > 0) {

            var datta = [];

            auto['addresses'].forEach(aut => {
                datta.push({
                    "boundingbox": aut['address']['boundingBox'],
                    "display_name": aut['address']['freeformAddress'],
                    "address": aut['address']['freeformAddress'],
                    "geojson": {
                        "type": "Point",
                        "coordinates": aut['position']
                            .split(',')
                            .map(Number)
                            .reverse()
                    },
                    "namedetails": {
                        "name": aut['address']['freeformAddress'],
                        "name:en": aut['address']['freeformAddress'],
                        "alt_name": aut['address']['freeformAddress']
                    },
                    "position": {
                        "lon": aut['position'].split(',')[0],
                        "lat": aut['position'].split(',')[1]
                    },
                    "localName": aut['address']['localName'],
                    "postalCode": aut['address']['postalCode'],
                    "municipality": aut['address']['municipality'],
                    "country": aut['address']['country'],
                    "countryCode": aut['address']['countryCode']
                });
            });

            var li,
                max = Math.min(self.get("maxItems"), datta.length);

            if (auto.length == 0) {

                li = document.createElement("LI");
                li.innerHTML = noItemsText;
                ul.appendChild(li);

            } else {

                for (var i = 0; i < max; i++) {
                    if (datta[i]) {
                        if (!i || !self.equalFeatures(datta[i], datta[i - 1])) {
                            if (datta[i]['type'] === 'FeatureCollection') {
                                li = document.createElement("LI");
                                li.setAttribute("data-search", this._list.length);
                                this
                                    ._list
                                    .push(datta[i]);
                                li.addEventListener("click", function (e) {
                                    self._handleSelect(self._list[
                                        e
                                            .currentTarget
                                            .getAttribute("data-search")
                                    ]);
                                });
                                var title = self.getTitle(datta[i]['features'][0]['properties']);
                                if (title instanceof Element) 
                                    li.appendChild(title);
                                else 
                                    li.innerHTML = title;
                                ul.appendChild(li);
                            } else {
                                li = document.createElement("LI");
                                li.setAttribute("data-search", this._list.length);
                                this
                                    ._list
                                    .push(datta[i]);
                                li.addEventListener("click", function (e) {
                                    self._handleSelect(self._list[
                                        e
                                            .currentTarget
                                            .getAttribute("data-search")
                                    ]);
                                });
                                var title = self.getTitle(datta[i]);
                                if (title instanceof Element) 
                                    li.appendChild(title);
                                else 
                                    li.innerHTML = title;
                                ul.appendChild(li);
                            }
                        }
                    }
                }

            }

        } else {

            if (isSearch) {

                var postal = this.get('search_postal');
                var city = this.get('search_city');

                if (postal && this.get('_useFilter') == true) {

                    var newAuto = [];

                    auto.forEach(aut => {
                        var address = aut['address'];
                        if (address) {
                            if (address['postalCode'] == postal) {
                                newAuto.push(aut);
                            }
                        } else {
                            if (aut['display_name'].includes(postal)) {
                                newAuto.push(aut);
                            }
                        }
                    });

                    auto = newAuto;

                } else if (city && this.get('_useFilter') == true) {

                    var newAuto = [];

                    auto.forEach(aut => {
                        var address = aut['address'];
                        if (address) {
                            if (address['municipality'] || address['localName']) {
                                if ((address['municipality'] && address['municipality'].toLowerCase() == city.toLowerCase()) || (address['localName'] && address['localName'].toLowerCase() == city.toLowerCase())) {
                                    newAuto.push(aut);
                                }
                            }
                        } else {
                            if (aut['display_name'].includes(city)) {
                                newAuto.push(aut);
                            }
                        }
                    });

                    auto = newAuto;

                }
            }

            var li,
                max = Math.min(self.get("maxItems"), auto.length);

            if (auto.length == 0) {
                li = document.createElement("LI");
                li.innerHTML = noItemsText;
                ul.appendChild(li);
            } else {

                for (var i = 0; i < max; i++) {
                    if (auto[i]) {
                        if (!i || !self.equalFeatures(auto[i], auto[i - 1])) {
                            if (auto[i]['type'] === 'FeatureCollection') {
                                li = document.createElement("LI");
                                li.setAttribute("data-search", this._list.length);
                                this
                                    ._list
                                    .push(auto[i]);
                                li.addEventListener("click", function (e) {
                                    self._handleSelect(self._list[
                                        e
                                            .currentTarget
                                            .getAttribute("data-search")
                                    ]);
                                });
                                var title = self.getTitle(auto[i]['features'][0]['properties']);
                                if (title instanceof Element) 
                                    li.appendChild(title);
                                else 
                                    li.innerHTML = title;
                                ul.appendChild(li);
                            } else {
                                li = document.createElement("LI");
                                li.setAttribute("data-search", this._list.length);
                                this
                                    ._list
                                    .push(auto[i]);
                                li.addEventListener("click", function (e) {
                                    self._handleSelect(self._list[
                                        e
                                            .currentTarget
                                            .getAttribute("data-search")
                                    ]);
                                });
                                var title = self.getTitle(auto[i]);
                                if (title instanceof Element) 
                                    li.appendChild(title);
                                else 
                                    li.innerHTML = title;
                                ul.appendChild(li);
                            }
                        }
                    }
                }
                if (max && this.get("copy")) {
                    li = document.createElement("LI");
                    li
                        .classList
                        .add("copy");
                    li.innerHTML = this.get("copy");
                    ul.appendChild(li);
                }
            }
        }
    }
}
